const currentDate = new Date().setHours(0, 0, 0, 0)

export default {
	adminDateFilter: {
		filterKey: "afterTs",

		filterOptions: [
			{
				display: "Today",
				value: new Date(currentDate).getTime().toString()
			},

			{
				display: "Last Two Days",
				value: new Date(currentDate - 86400000).getTime().toString()
			},

			{
				display: "Last Seven Days",
				value: new Date(currentDate - 518400000).getTime().toString()
			},

			{
				display: "Last Month",
				value: new Date(currentDate - 2592000000).getTime().toString()
			},

			{
				display: "Last Two Months",
				value: new Date(currentDate - 5184000000).getTime().toString()
			},

			{
				display: "Last Year",
				value: new Date(currentDate - 31536000000).getTime().toString()
			},

			{
				display: "All",
				value: "0"
			}
		],

		defaultFilter: {
			display: "Today",
			value: new Date(currentDate).getTime().toString()
		}
	},

	employerDateFilter: {
		filterKey: "afterTs",

		filterOptions: [
			{
				display: "Last Month",
				value: new Date(currentDate - 2592000000).getTime().toString()
			},

			{
				display: "Last Two Months",
				value: new Date(currentDate - 5184000000).getTime().toString()
			},

			{
				display: "Last Year",
				value: new Date(currentDate - 31536000000).getTime().toString()
			},

			{
				display: "All",
				value: "0"
			}
		],

		defaultFilter: {
			display: "Last Month",
			value: new Date(currentDate - 2592000000).getTime().toString()
		}
	},

	employeeStatusFilter: {
		filterKey: "status",

		filterOptions: [
			{
				display: "Employees",
				value: "employees"
			},


			{
				display: "Enrolled",
				value: "enrolled"
			},

			// {
			// 	display: "Not-Eligible",
			// 	value: "not-eligible"
			// },

			// {
			// 	display: "Terminated",
			// 	value: "terminated"
			// },

			// {
			// 	display: "All",
			// 	value: "all"
			// }
		],

		defaultFilter: {
			display: "Employees",
			value: "employees"
		}
	},
	ichraEmployeeStatusFilter: {
		filterKey: "status",

		filterOptions: [
			{
				display: "Employees",
				value: "employees"
			},

			{
				display: "Eligible",
				value: "eligible"
			},

			{
				display: "Enrolled",
				value: "enrolled"
			},

			// {
			// 	display: "Not-Eligible",
			// 	value: "not-eligible"
			// },

			// {
			// 	display: "Terminated",
			// 	value: "terminated"
			// },

			// {
			// 	display: "All",
			// 	value: "all"
			// }
		],

		defaultFilter: {
			display: "Employees",
			value: "employees"
		}
	},

	requestMethodFilter: {
		filterKey: "method",

		filterOptions: [
			{
				display: "ALL",
				value: "all"
			},

			{
				display: "GET",
				value: "get"
			},

			{
				display: "POST",
				value: "post"
			},

			{
				display: "PATCH",
				value: "patch"
			},

			{
				display: "DELETE",
				value: "delete"
			}
		],

		defaultFilter: {
			display: "ALL",
			value: "all"
		}
	}
}
